import { render } from "./HorizontalMultiBarChart.vue?vue&type=template&id=2075d2c1&scoped=true"
import script from "./HorizontalMultiBarChart.vue?vue&type=script&lang=js"
export * from "./HorizontalMultiBarChart.vue?vue&type=script&lang=js"

import "./HorizontalMultiBarChart.vue?vue&type=style&index=0&id=2075d2c1&lang=scss&scoped=true"

import exportComponent from "/builds/retina-v5/principal-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2075d2c1"]])

export default __exports__